import type { AppStatus, DeploymentStatus } from '@xb/shared';

const LABELS: Record<AppStatus | DeploymentStatus, string> = {
  provisioning: 'Setting up',
  active: 'Running',
  stopped: 'Stopped',
  deleting: 'Deleting',
  failed: 'Failed',
  uploaded: 'Uploaded',
  building: 'Building',
  releasing: 'Releasing',
  live: 'Live',
};

export function StatusPill({ status }: { status: AppStatus | DeploymentStatus }) {
  return <span className={`pill pill-${status}`}>{LABELS[status] ?? status}</span>;
}

export function TypeBadge({ type }: { type: 'static' | 'server' }) {
  return <span className="badge">{type === 'static' ? 'Static site' : 'Server app'}</span>;
}
